import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
    name: 'urlbasename',
})
export class UrlBasenamePipe implements PipeTransform {
    public transform(value: string): string {
        return decodeURI(value.substring(value.lastIndexOf('/') + 1));
    }
}
